import { determineErrorPageDetails } from './determineErrorPageDetails';

export const getErrorPageContent = () => {
  const { description, title } = determineErrorPageDetails();
  return {
    root: 'ErrorPage',
    components: {
      ErrorPage: {
        type: 'Layout',
        properties: {},
        children: ['ErrorContainer'],
      },
      ErrorContainer: {
        type: 'ErrorContainer',
        properties: {
          title,
          description,
        },
        children: [],
      },
    },
  };
};
